export const PRODUCT_CLASSIFICATION_PREFIX = 'productClassificationPrefix';
export const CUSTOMER_CLASSIFICATION_PREFIX = 'customerClassificationPrefix';
export const SALES_TARGET_PRODUCT_CLASSIFICATION_PREFIX = 'salesTargetProductClassificationPrefix';
export const SALES_TARGET_CUSTOMER_CLASSIFICATION_PREFIX =
  'salesTargetCustomerClassificationPrefix';

export const SALES_TARGET_REPORTS_FILTERS_KEYS = {
  salesTargetsIds: 'salesTargetsIds',
  salesTargetNamesIds: 'salesTargetNamesIds',
  salesRepresentative: 'salesRepresentativeIds',
  endDate: 'endDate',
  startDate: 'startDate',
  dateShortcut: 'dateShortcut',
  salesTargetStatus: 'salesTargetStatus',
  orderStatus: 'orderStatus',
  salesTargetOrderCollections: 'salesTargetOrderCollectionsIds',
  salesTargetProductCollections: 'salesTargetProductCollectionsIds',
  salesTargetAvailability: 'salesTargetAvailability',
  productAvailability: 'productAvailability',
  salesTargetDeliveryWindows: 'salesTargetDeliveryWindowsIds',
  orderDeliveryWindows: 'orderDeliveryWindowsIds',
  salesTargetProductClassifications: 'salesTargetProductClassificationsIds',
  salesTargetCustomerClassifications: 'salesTargetCustomerClassificationsIds',
  productClassifications: 'productClassificationsIds',
  customerClassifications: 'customerClassificationsIds',
};
